import { Pipe, PipeTransform } from '@angular/core';

import { Location } from '@sondermind/utilities/models-location';

@Pipe({
  name: 'formatAddress',
  standalone: true,
})
export class FormatAddressPipe implements PipeTransform {
  transform(location: Location | null | undefined): string {
    if (!location) {
      return '';
    }
    const addressParts = [
      location.addressLine1,
      location.addressLine2 ? `, ${location.addressLine2}` : '',
      `, ${location.city}, ${location.state} ${location.postalCode}`
    ];
    return addressParts.join('');
  }
}
